// components/Sidebar.js
import React, { useEffect, useState } from 'react';
import {
    Box, Drawer, Typography, IconButton, List, ListItem,
    ListItemButton, ListItemIcon, ListItemText, Avatar
} from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import { Link, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {
    BarChart as DashboardIcon,
    Inventory as InventoryIcon,
    Paid as PriceIcon,
    Category as PackageIcon,
    DescriptionOutlined as ContractIcon,
    ReceiptLong as ReceiptLongIcon,
    Receipt as ReceiptIcon,
    AccountCircle as UserIcon
} from '@mui/icons-material';
import ApiIcon from '@mui/icons-material/Api';

const drawerWidth = 260;

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: drawerWidth,
        boxSizing: 'border-box',
        backgroundColor: '#FFF',
        color: '#999ea6',
    },
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
    color: '#ffffff',
}));

const BrandBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
}));

export default function Sidebar({ open, handleDrawerClose, onMenuSelect }) {
    const location = useLocation();
    const [menuItems, setMenuItems] = useState([]);
    const [userData, setUserData] = useState(null);
    const avatarUrl = userData?.avatar ? `${process.env.REACT_APP_API_URL}/uploads/avatars/${userData.avatar}` : '';


    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            const user = JSON.parse(storedUser);
            setUserData(user);

            switch (user.usertypeid) {
                case 1: // Full access Admin
                    setMenuItems([
                        { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
                        { text: 'Users', icon: <UserIcon />, path: '/users' },
                        { text: 'Items', icon: <InventoryIcon />, path: '/items' },
                        { text: 'Prices', icon: <PriceIcon />, path: '/prices' },
                        { text: 'Packages', icon: <PackageIcon />, path: '/packages' },
                        { text: 'Contracts', icon: <ContractIcon />, path: '/contracts' },
                        { text: 'Invoices', icon: <ReceiptLongIcon />, path: '/invoices' },                        { text: 'Receipts ', icon: <ReceiptIcon />, path: '/receipts' },
                        { text: 'Customers', icon: <ApiIcon />, path: '/customers' }
                    ]);
                    break;
                case 2: // Limited access Sales Manager 
                    setMenuItems([
                        { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
                        { text: 'Team', icon: <ApiIcon />, path: '/Team' },
                        { text: 'Packages', icon: <PackageIcon />, path: '/packages' },
                        { text: 'Contracts', icon: <ContractIcon />, path: '/contracts' },

                    ]);
                    break;
                case 3: // Packages & Contracts only Sales Person
                    setMenuItems([
                        { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
                        { text: 'Contracts', icon: <ContractIcon />, path: '/contracts' },
                    ]);
                    break; case 4: // Invoices & Receipts only Accountant
                    setMenuItems([
                        { text: 'Invoices', icon: <ReceiptLongIcon />, path: '/' },
                        { text: 'Receipts', icon: <ReceiptIcon />, path: '/receipts' }
                    ]);
                    break;
                default:
                    setMenuItems([{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' }]);
            }
        }
    }, []);


    return (
        <StyledDrawer variant="persistent" anchor="left" open={open}>
            <DrawerHeader>
                <BrandBox>
                    <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '0.5px' }}>
                        <center>
                            <img
                                src="https://jobsnprofiles.com/static/media/logo-light-bg.3ca0586747e457941f0d.png"
                                style={{ width: "100%" }}
                                alt="Logo"
                            />
                        </center>
                    </Typography>
                </BrandBox>
                <IconButton onClick={handleDrawerClose} sx={{ color: '#000' }}>
                    <ChevronLeftIcon />
                </IconButton>
            </DrawerHeader>
{/* 
            {userData && (
                <Box sx={{ p: 2, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ bgcolor: '#FFF', width: 40, height: 40 }}

                            src={avatarUrl}
                            alt={userData.name}
                        />
                        <Box sx={{ ml: 2 }}>
                            <Typography variant="subtitle1" sx={{ color: '#000', fontWeight: 500 }}>
                                {userData.name || 'User'}
                            </Typography>
                            <Typography variant="subtitle2" sx={{ color: '#000', fontWeight: 500, fontSize: "12px" }}>
                                {userData.email || 'User'}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )} */}

            <Box sx={{ px: 2, py: 1 }}>
                {/* <Typography variant="caption" sx={{ color: '#6b7a99', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Main Navigation
                </Typography> */}
            </Box>

            <List sx={{ px: 1 }}>
                {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <ListItem
                            key={item.text}
                            disablePadding
                            component={Link}
                            to={item.path}
                            sx={{
                                textDecoration: 'none',
                                color: isActive ? '#2196f3' : '#000',
                                my: 0.5,
                                borderRadius: 1,
                            }}
                            onClick={() => onMenuSelect && onMenuSelect(item.text)}
                        >
                            <ListItemButton
                                sx={{
                                    borderRadius: 1,
                                    backgroundColor: isActive ? alpha('#2d8ff5', 0.3) : 'transparent',
                                    '&:hover': {
                                        backgroundColor: alpha('#2d8ff5', 0.1), // Add hover background color
                                    },
                                    py: 1,
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 44,
                                        color: isActive ? '#2d8ff5' : '#a9b7d0',
                                    }}
                                >
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.text}
                                    primaryTypographyProps={{
                                        fontWeight: isActive ? 600 : 400,
                                        fontSize: '0.9rem',
                                    }}
                                />
                                {isActive && (
                                    <Box
                                        sx={{
                                            width: 3,
                                            height: 20,
                                            bgcolor: '#2d8ff5',
                                            borderRadius: 3,
                                            position: 'absolute',
                                            left: 0,
                                        }}
                                    />
                                )}
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </List>
        </StyledDrawer>
    );
}
